class PDPAnchorNav extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('a');
    this.links.forEach(currentLink => {
      const linkTarget = document.querySelector(`${currentLink.getAttribute('href')}`);
      if (!linkTarget) {
        currentLink.parentElement.classList.add('hidden');
      }
      currentLink.addEventListener('click', this.onLinkClick.bind(this));
    });

    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--scroll-margin-top', `${this.offsetHeight + headerHeight}px`);

    if (window.location.hash) {
      const pageLoadAnchor = this.querySelector(`a[href="${window.location.hash}"]`);
      if (pageLoadAnchor) {
        pageLoadAnchor.click();
      }
    }
  }

  expandAccordion(anchor) {
    if (anchor && anchor.getAttribute('href')) {
      const scrollTarget = document.querySelector(anchor.getAttribute('href'));
      if (scrollTarget && scrollTarget.querySelector('&.expand-with-pdp-anchor details-accordion')) {
        scrollTarget.querySelector('details-accordion').open(0);
      }
    }
  }

  onLinkClick(e) {
    const anchor = e.target;
    const activeLink = this.querySelector('.active');

    this.expandAccordion(anchor);

    if (activeLink) {
      activeLink.classList.remove('active');
    }

    anchor.classList.add('active');
  }
}

customElements.define('pdp-anchor-nav', PDPAnchorNav);
